import "./Home.css";
import React, { useEffect, useRef, useState } from "react";
import GlobalSearch from "../../components/GlobalSearch/GlobalSearch";
import { Button } from "@mui/material";
import MenuCards from "../../components/MenuCards/MenuCards";
// import ProductCard from "../../components/ProductCard/ProductCard";
// import { ChevronLeftSharp, ChevronRightSharp } from "@mui/icons-material";
// import PageTitle from "../../components/PageTitle/PageTitle";
// import customHttp from "../../services/customHTTP";
// import { useSite } from "../../context/siteContext";
import { useNavigate } from "react-router-dom";
import { ASSETS_BASE_URL } from "../../config";

const HomeMenuitems = [
	{ label: "My Machines", path: "/machines" },
	{ label: "Documents", path: "/documents" },
	{ label: "RSPL", path: "/rspl" },
	{ label: "Order History", path: "/order-history" },
];

function Home() {
	// const [bestSellers, setBestSellers] = useState([]);
	// const { selectedSite } = useSite();
	const prodsRef = useRef(null);
	const navigate = useNavigate();

	// const scrollSmoothly = (direction) => {
	// 	if (prodsRef.current) {
	// 		const scrollContainer = prodsRef.current;
	// 		const scrollAmount = 400;
	// 		let start = null;
	// 		const initialScroll = scrollContainer.scrollLeft;
	// 		const targetScroll = direction === "left" ? initialScroll - scrollAmount : initialScroll + scrollAmount;

	// 		const step = (timestamp) => {
	// 			if (!start) start = timestamp;
	// 			const progress = timestamp - start;
	// 			const easing = Math.min(progress / 500, 1); // Customize easing (300ms duration)
	// 			scrollContainer.scrollLeft = initialScroll + (targetScroll - initialScroll) * easing;

	// 			if (easing < 1) {
	// 				window.requestAnimationFrame(step);
	// 			}
	// 		};

	// 		window.requestAnimationFrame(step);
	// 	}
	// };

	// useEffect(() => {
	// 	const fetchBestSellers = async () => {
	// 		try {
	// 			const req_body = {
	// 				site_number: selectedSite,
	// 			};
	// 			const response = await customHttp.post("/products/bysiteid", req_body);
	// 			if (response.status === 200) {
	// 				const randomProducts = response.data.data.sort(() => Math.random() - 0.5).slice(0, 25);
	// 				setBestSellers(randomProducts);
	// 				console.log(response);
	// 			}
	// 		} catch (error) {
	// 			console.error("Error fetching products:", error);
	// 		}
	// 	};
	// 	fetchBestSellers();
	// }, [selectedSite]);

	// // Function to scroll left
	// const scrollLeft = () => scrollSmoothly("left");

	// // Function to scroll right
	// const scrollRight = () => scrollSmoothly("right");

	return (
		<div style={{ minHeight: "80vh", paddingTop: "0px" }}>
			<div className="home-slider" style={{ backgroundImage: `url('${ASSETS_BASE_URL}/home_bg3.jpg')` }}>
				<GlobalSearch width="70%" />
			</div>
			<div className="home-content">
				<div className="home-content-left">
					<h2>Revolutionize Your Manufacturing with BPA</h2>
					<div className="header-divider"></div>
					<p>
						Rethinking your secondary packaging needs? Welcome to BluePrint Automation (BPA). <br />
						We design, develop and manufacture case packers and tray packing solutions for flexible and
						other tough-to-handle packages such as doypacks, pillow bags and four-sided sealed bags.
					</p>

					<Button
						variant="contained"
						className="button-primary"
						onClick={() => {
							navigate("/my-lists");
						}}>
						View My Lists
					</Button>
				</div>
				<div className="homeDividerh"></div>
				<div className="home-content-right">
					{HomeMenuitems.map((item, index) => (
						<MenuCards key={index} label={item.label} path={item.path} />
					))}
				</div>
			</div>
			{/* <div className="home-reccommendations">
				<PageTitle title="Best Sellers" />
				<div className="rec-products">
					<div className="iconLeft" onClick={scrollLeft}>
						<ChevronLeftSharp
							sx={{
								height: "80px",
								width: "80px",
							}}
						/>
					</div>
					<div className="prods" ref={prodsRef}>
						{bestSellers.map((product, index) => (
							<ProductCard
								key={`${product.product_id}_${index}`}
								product={product}
								machineID={product.machine_id}
								showSavedForLaterDial={true}
							/>
						))}
					</div>
					<div className="iconRight" onClick={scrollRight}>
						<ChevronRightSharp
							sx={{
								height: "80px",
								width: "80px",
							}}
						/>
					</div>
				</div>
			</div> */}
		</div>
	);
}

export default Home;
